import { toast } from '@/components/toast';
import { deletePresenter } from '@/pages/avatar/api';
import { useAnalytics } from '@/services/analytics';
import { GET_PRESENTERS_KEY, GET_PRESENTERS_KEY_TYPE } from '@/state/presenters/presenters';
import { MixPanelEvent } from '@/utils/types';
import { ImageType } from '@d-id/types';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { AvatarType, MixpanelGroupEventDelete } from '../common';
import { VALIDATE_USER_CAPPING_QUERY_KEY } from './useValidateUserCapping';

export function useDeletePresenter() {
    const mixpanel = useAnalytics();
    const queryClient = useQueryClient();

    return useMutation(deletePresenter, {
        async onSuccess() {
            await queryClient.invalidateQueries([GET_PRESENTERS_KEY, GET_PRESENTERS_KEY_TYPE(ImageType.Upload)]);
            await queryClient.invalidateQueries(VALIDATE_USER_CAPPING_QUERY_KEY);
            mixpanel?.track(MixpanelGroupEventDelete.Avatar, {
                event: MixPanelEvent.SUCCESS,
                itemType: AvatarType.PremiumPlus,
            });
        },

        onError(error: AxiosError<{ kind: string; description?: string }>) {
            const kind = error?.response?.data?.kind;
            const description = error?.response?.data?.description;
            mixpanel?.track(MixpanelGroupEventDelete.Avatar, {
                kind,
                event: MixPanelEvent.ERROR,
                itemType: AvatarType.PremiumPlus,
            });
            if (description === 'Presenter has public agents and cannot be deleted') {
                toast.error({
                    title: `Can't delete avatar`,
                    message: 'This avatar is currently used in an active Agent. To delete it, first change the presenter in that Agent.',
                    toastId: `delete-presenter-with-agents-error`,
                });
            } else {
                toast.error({ title: 'Failed to delete avatar, please try again', toastId: `delete-presenter-error` });
            }
        },
    });
}
